import useEditor from 'client/widget-components/customHooks/useEditor';
import { ProductEntity } from 'client/widget-components/ecom/stores/types';
import { getWindowInBrowser } from 'client/RuntimeWindow';
import { logger } from '@shared-services/log-service';

const { isInPreviewOrEditor } = useEditor();

/**
 * After ecom ready, session (including `defaultCurrency`) is consistent for analytics payloads.
 */
export async function prepareAndSendGAItemViewEvent(
    product: ProductEntity
): Promise<void> {
    if (!window?.runtime || isInPreviewOrEditor()) {
        return;
    }
    if (!window._ecomm) {
        return;
    }

    try {
        await window._ecomm.ready;
        sendGAEvent('view_item', product.price, getViewItemPayload(product));
    } catch (error) {
        logger.error({
            message: 'Error sending view item analytics event',
            error,
        });
    }
}

function getNameFromProduct(product: ProductEntity) {
    try {
        const variationChoices = product.selected_options_values
            ? JSON.parse(product.selected_options_values)
            : {};

        if (Object.keys(variationChoices).length == 0) return product.name;

        const spaceSeparatedSelectedChoices = `${Object.values(
            variationChoices
        ).join(' ')}`;
        return `${product.name} ${spaceSeparatedSelectedChoices}`;
    } catch (error) {
        logger.error({
            message: `Error getting name from product`,
            error,
        });
        return product.name;
    }
}

function getViewItemPayload(product: ProductEntity) {
    let name = getNameFromProduct(product);

    return {
        currency: window
            ._ecomm!.state.session
            .storeSettings.defaultCurrency.toUpperCase(),
        items: [
            {
                item_id: product.itemId, //GA4
                item_name: name, //GA4
                id: product.itemId, //UA
                name, //UA
                price: product.price,
                description: product.description,
            },
        ],
    };
}

function sendGAEvent(event: string, value: number, payload: any) {
    window?.runtime?.tagManagerAPI.sendGAEvent({
        category: event,
        action: event,
        value: value,
        siteAlias: getWindowInBrowser()?.Parameters?.SiteAlias,
        payload: payload,
    });
}
